// removed by extract-text-webpack-plugin
module.exports = {"container":"_70ec8417aa_src-common-_Badge_container","badge":"_05ce9b2ab8_src-common-_Badge_badge"};


//////////////////
// WEBPACK FOOTER
// ./src/common/Badge.css
// module id = 1018
// module chunks = 0